module.exports = __webpack_public_path__ + "img/8.b5a7580b.svg";